import { TemplatePageProps } from './types'
import { CashPoolEntity } from './entity'
import Icon from 'images/games/cash-pool/icon.png'
import Swiper1 from 'images/games/cash-pool/swiper1.webp'
import Swiper2 from 'images/games/cash-pool/swiper2.webp'
import Swiper3 from 'images/games/cash-pool/swiper3.webp'
import Swiper4 from 'images/games/cash-pool/swiper4.webp'
import Swiper5 from 'images/games/cash-pool/swiper5.webp'
import Detail1 from 'images/games/cash-pool/detail1.png'
import Detail2 from 'images/games/cash-pool/detail2.png'
import Detail3 from 'images/games/cash-pool/detail3.png'
import Footer from 'images/games/cash-pool/footer.png'
import { EightBallStrikeLink, GamesLink, TextLink } from '../../components'

export const CashPoolDetail: TemplatePageProps = {
  entity: {
    ...CashPoolEntity,
    logo: Icon,
    title: <>Cash Pool: The Best Online Pool Game Experience</>,
    description: (
      <>
        If you&#39;re looking for a <strong>pool game</strong> that goes beyond the basics,{' '}
        <strong>8 Ball Strike: Cash Pool</strong> is where strategy meets skill—and where every shot can give you the
        opportunity to win real cash rewards! Play exciting real-time <strong>online pool</strong> matches, hone your
        billiards instincts, and rise through competitive ranks in this next-level <strong>online pool</strong>{' '}
        experience. Download now and see what makes this <strong>8 ball online</strong> game different from the rest!
      </>
    ),
  },
  swiper: [{ image: Swiper1 }, { image: Swiper2 }, { image: Swiper3 }, { image: Swiper4 }, { image: Swiper5 }],
  content: [
    {
      title: <>How to Play Cash Pool and Master the 8 Pool Game</>,
      description: (
        <>
          <strong>8 Ball Strike: Cash Pool</strong> sticks to the official rules, features horizontal gameplay, and
          delivers smooth, real-time 1v1 matches on the same virtual table as your opponent. With head-to-head matchups,
          victory comes down to pure skill and clever strategy. Use precision to win the break in Best Shot, then aim
          for stripes or solids, call the <strong>8 ball</strong>, and avoid costly fouls. Whether you&#39;re just
          learning the ropes or a seasoned <strong>billiards online</strong> enthusiast, responsive physics and refined
          cue mechanics give you full control over every shot.
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Skill-Based Competition, Real Cash Prizes</>,
      description: (
        <>
          What sets <strong>8 Ball Strike</strong> apart from other <strong>pool games online</strong>? With lightning
          fast match response times and skill-based matchmaking, every game is fair and delivers a smooth, seamless
          experience. Along the way, unlock custom cues with special effects to match your style. The game is about
          smart moves, accurate shots, and strategic plays, making every decision matter. Climb the leaderboard and earn
          rewards in this ultimate <strong>8 pool</strong> challenge!
        </>
      ),
      image: Detail2,
    },
    {
      title: <>Fast, Trusted Payments You Can Count On</>,
      description: (
        <>
          When it comes to rewards, Avia keeps it simple and secure. Withdraw your earnings quickly through PayPal, and
          make hassle-free deposits using PayPal, Venmo, Apple Pay, Visa, Mastercard, Amex, and Discover. With 24/7{' '}
          <TextLink href="/support">customer support</TextLink>, we’ve got you covered so you can stay focused on your
          next win in your favorite <strong>pool game</strong>.
        </>
      ),
      image: Detail3,
    },
    {
      title: <>Play Now and Explore More Pool Games Online</>,
      description: (
        <>
          Ready to enjoy <strong>8 ball online</strong> the way it’s meant to be played? Whether you&#39;re in it for
          casual rounds or the competitive thrill, this <strong>online pool</strong> game delivers.
          <br />
          <br />
          Download 8 Ball Strike: Cash Pool now and check out more <GamesLink>Aviagames</GamesLink>, including other
          other exciting titles like <EightBallStrikeLink>8 Ball Strike: Win Real Cash</EightBallStrikeLink>, a
          multiplayer-friendly billiards online game perfect for casual matches and fast-paced fun.
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
} as TemplatePageProps
